module.exports = __webpack_public_path__ + "img/trees-silhouette-1.1be0f8a3.png";